import React, { ReactElement } from 'react';

import { Stamp, StampIcon } from '@philips-emr/tws-components';
import { Color } from '@philips-emr/tws-constants';

enum CallsStatus {
  OPEN = '1',
  PENDING = '2',
  CLOSED = '3',
  CANCELED = '4',
}

interface CallsData {
  dsStatus: string;
  cdStatus: CallsStatus;
  dtOpenning: Date;
  isDateValid: boolean;
  isNameValid: boolean;
  guidance: string;
}

function getIconTypeByStatus(cdStatus: CallsStatus): StampIcon {
  const icon = {
    [CallsStatus.OPEN]: StampIcon.CHECK,
    [CallsStatus.PENDING]: StampIcon.CLOCK,
    [CallsStatus.CLOSED]: StampIcon.CHECK,
    [CallsStatus.CANCELED]: StampIcon.CANCELED,
  };

  return icon[cdStatus];
}

function getIconColorByStatus(cdStatus: CallsStatus): Color {
  const color = {
    [CallsStatus.OPEN]: Color.SAFETY_NEUTRAL,
    [CallsStatus.PENDING]: Color.SAFETY_BLUE,
    [CallsStatus.CLOSED]: Color.SAFETY_GREEN,
    [CallsStatus.CANCELED]: Color.SAFETY_RED,
  };

  return color[cdStatus];
}

function getStampByStatus(cdStatus: CallsStatus, dsStatus: string): ReactElement {
  return (
    <Stamp icon={getIconTypeByStatus(cdStatus)} color={getIconColorByStatus(cdStatus)} label={dsStatus} />
  );
}

export type {
  CallsData,
};

export {
  getStampByStatus,
};
